// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preferences-defaults-container[data-v-41dba29e]{flex:1;display:flex;flex-flow:column;padding-top:.5rem}.defaults-container[data-v-41dba29e]{flex:1;overflow:auto;padding:1rem;max-width:48rem}.checkRadio[data-v-41dba29e]{padding:.25rem 0}@media only screen and (min-width:768px){.defaults-container[data-v-41dba29e]{width:48rem;margin:0 auto}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
